<template>
  <el-select v-model="zsHomepage"
    style="vertical-align: top;"
    placeholder="请选择网址">
    <el-option v-for="(item, index) in list"
      :key="index"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'home-page-select',
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      list: []
    }
  },
  computed: {
    zsHomepage: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    fetchList () {
      this.$store.dispatch('common/getzshomepages', {
        payload: {
          pageNum: 1,
          pageSize: 1000
        },
        success: (res) => {
          this.list = res.data.records
        },
        fail: () => {
          this.list = []
        }
      })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
